import * as yup from 'yup';

export const CreateForm = (requiresFacturaA: boolean): any => {
  return yup.object({
    orderId: yup.number().required('El número de orden es requerido'),
    email: yup.string().email('El correo electrónico debe tener formato de email').required('El correo electrónico es obligatorio'),
    cuit: yup.lazy(() => {
      const validation = yup.string();
      return requiresFacturaA ? validation.required('El CUIT es obligatorio para factura A').matches(/^\d{11}$/, 'Formato de CUIT inválido')
      .test('cuit-valido', 'CUIT inválido', value => {
        if (!value) return true; // Permite valores vacíos si es opcional
    
        if (value.length !== 11) return false;
    
        const coeficientes = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2];
        const digitoVerificador = value.charAt(10);
        let suma = 0;
    
        for (let i = 0; i < 10; i++) {
          suma += parseInt(value.charAt(i)) * coeficientes[i];
        }
    
        const resultado = suma % 11;
        const digitoCalculado = resultado === 0 ? 0 : resultado === 1 ? 9 : 11 - resultado;
    
        return parseInt(digitoVerificador) === digitoCalculado;
      }) : validation.nullable();
    }),
  });
};
